<script>
    import { getContext } from 'svelte'

    import MobileMenuButton from './MobileMenuButton.svelte'

    export let items = []

    const { handleSelect } = getContext('menu')
</script>

<div class="desktop-wrapper">
    {#each items as item }
        <div on:click={() => handleSelect(item.id)}>{item.title}</div>
    {/each}
</div>

<div class="mobile-wrapper">
    <MobileMenuButton />
</div>

<style lang="scss">
    .desktop-wrapper {
        display: flex;
        align-items: center;

        > div {
            margin-right: 40px;
            font-size: 16px;
            line-height: 20px;
            color: #282F3C;
            cursor: pointer;
        }
    }

    .mobile-wrapper {
        display: none;
    }

    @media (max-width: 834px) {
        .desktop-wrapper {
            display: none;
        }

        .mobile-wrapper {
            display: block;
        }
    }
</style>